/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stale_Reload_DescInputs */

const en_stale_reload_desc = /** @type {(inputs: Stale_Reload_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reload the page to continue.`)
};

const id_stale_reload_desc = /** @type {(inputs: Stale_Reload_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muat ulang halaman untuk melanjutkan.`)
};

/**
* | output |
* | --- |
* | "Reload the page to continue." |
*
* @param {Stale_Reload_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const stale_reload_desc = /** @type {((inputs?: Stale_Reload_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stale_Reload_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_stale_reload_desc(inputs)
	return en_stale_reload_desc(inputs)
});